import { useEffect, useState } from 'react';

import { Button, type ButtonAction } from '@dec/shared';
import type React from 'react';

export interface ActionColumn {
  disable?: (row: any) => boolean;
  action?: ButtonAction;
  label?: string;
  icon?: React.ElementType;
  visible?: boolean;
  variant: 'primary' | 'secondary' | 'danger';
  onClick: (row: any, extraParm?: any) => void;
  onlyIcon?: boolean;
}
interface Props {
  actions: Array<ActionColumn>;
  rowIndex: number;
  data: any;
  lista?: () => Array<any>;
}
function ActionsColumn({ actions, rowIndex, data, lista }: Props) {
  const [buttons, setButtons] = useState<any>([]);
  useEffect(() => {
    setButtons(actions);
  }, []);
  const mapAction = (actions: Array<ActionColumn>, row: number) => {
    return actions.map((item: ActionColumn, index: number) => {
      const spaceLeft = index > 0 ? ' ml-1' : '';
      return (
        <Button
          className={'btn-sm' + spaceLeft}
          key={`${rowIndex}-action-${index}`}
          variant={item.variant}
          icon={item.icon}
          onlyIcon={item.onlyIcon === undefined ? true : false}
          action={item.action}
          visible={item.visible === undefined ? true : item.visible}
          onClick={() => item.onClick(row, lista)}
          disabled={item.disable ? item.disable(row) : false}
        />
      );
    });
  };

  return <>{mapAction(buttons, data)}</>;
}

export default ActionsColumn;
